namespace GeniuzPOS.Purchase {
    export namespace PoInvoiceReceiveDtService {
        export const baseUrl = 'Purchase/PoInvoiceReceiveDt';

        export declare function Create(request: Serenity.SaveRequest<PoInvoiceReceiveDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoInvoiceReceiveDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoInvoiceReceiveDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoInvoiceReceiveDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoInvoiceReceiveDt/Create",
            Update = "Purchase/PoInvoiceReceiveDt/Update",
            Delete = "Purchase/PoInvoiceReceiveDt/Delete",
            Retrieve = "Purchase/PoInvoiceReceiveDt/Retrieve",
            List = "Purchase/PoInvoiceReceiveDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoInvoiceReceiveDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
